import React from 'react';
import { PureTableCell } from 'src/pages/OfferPage/TableSvgOrganizer/PureTableCell';
import { IDetails } from 'src/pages/OfferPage/TableSvgOrganizer/IDetails';
import { CustomModifyRow } from "src/pages/OfferPage/TableSvgOrganizer/CustomModifyRow";
import { ProjectQuoteUserProperties } from "src/model/api/project.model";
import { GetAllManufacturerDiscountForProjectResponse } from "src/model/api/manufacturer-discount.model";
import { ManufacturerRecommendationResponse } from "src/model/api/manufacturer-recommendation";
import { CustomModifyMinusRow } from "src/pages/OfferPage/TableSvgOrganizer/CustomModifyMinusRow";
import { addMinusRow, deleteCustomItem } from "src/utils/CustomRowUtils";
import {
    useAddCableCustomItemMutation,
    useAddConventionalDevicesCustomItemMutation,
    useAddElectricalCustomItemMutation,
    useAddNhcCustomItemMutation,
    useAddProjectCustomItemMutation,
    useAddRackCabinetCustomItemMutation,
    useAddRoomCustomItemMutation,
    useDeleteCableCustomItemMutation,
    useDeleteConventionalDevicesCustomItemMutation,
    useDeleteElectricalCustomItemMutation,
    useDeleteNhcCustomItemMutation,
    useDeleteProjectCustomItemMutation,
    useDeleteRackCabinetCustomItemMutation,
    useDeleteRoomCustomItemMutation
} from "src/api/v1/quote-ApiSlice";
import { useAddCustomSectionItemMutation, useDeleteCustomSectionItemMutation } from "src/api/v1/section-ApiSlice";
import { RowTools } from "src/pages/OfferPage/TableSvgOrganizer/RowTools/RowTools";
import { ResetButton } from "src/pages/OfferPage/TableSvgOrganizer/ResetButton";

export const PureTableRow = (
    {
      projectId,
      index,
      table,
      rows,
      row,
      neededCols,
      currency,
      setCustomMinusRowButtonPressed,
      setCustomMinusItem,
      modifyMinusRow,
      setModifyMinusRow,
      dispatchDownloadStates,
      modifyMode,
      setModifyMode,
      detailsEnabled,
      allCols,
      icons,
      currentRowInEditing,
      setCurrentRowInEditing,
      measurementSystem,
      quoteUserProperties,
      allManufacturerDiscountForProject,
      manufacturerRecommendationForProject,
    }: {
      projectId: number;
      index: number;
      table: any;
      rows: any;
      row: any;
      neededCols: any;
      currency: string;
      setCustomMinusRowButtonPressed: any;
      setCustomMinusItem: any;
      modifyMinusRow: any;
      setModifyMinusRow: any;
      dispatchDownloadStates: any;
      modifyMode: any;
      setModifyMode: any;
      detailsEnabled: boolean;
      allCols: any;
      icons: any;
      currentRowInEditing: any;
      setCurrentRowInEditing: any;
      measurementSystem: string;
      quoteUserProperties: ProjectQuoteUserProperties;
      allManufacturerDiscountForProject: GetAllManufacturerDiscountForProjectResponse;
      manufacturerRecommendationForProject: ManufacturerRecommendationResponse;
    }
) => {

  const [ addRoomCustomItem ] = useAddRoomCustomItemMutation();
  const [ addProjectCustomItem ] = useAddProjectCustomItemMutation();
  const [ addElectricalCustomItem ] = useAddElectricalCustomItemMutation();
  const [ addNhcCustomItem ] = useAddNhcCustomItemMutation();
  const [ addCustomSectionItem ] = useAddCustomSectionItemMutation();
  const [ addRackCabinetCustomItem ] = useAddRackCabinetCustomItemMutation();
  const [ addCableCustomItem ] = useAddCableCustomItemMutation();
  const [ addConventionalDevicesCustomItem ] = useAddConventionalDevicesCustomItemMutation();

  const [ deleteRoomCustomItem ] = useDeleteRoomCustomItemMutation();
  const [ deleteProjectCustomItem ] = useDeleteProjectCustomItemMutation();
  const [ deleteElectricalCustomItem ] = useDeleteElectricalCustomItemMutation();
  const [ deleteNhcCustomItem ] = useDeleteNhcCustomItemMutation();
  const [ deleteCustomSectionItem ] = useDeleteCustomSectionItemMutation();
  const [ deleteRackCabinetCustomItem ] = useDeleteRackCabinetCustomItemMutation();
  const [ deleteCableCustomItem ] = useDeleteCableCustomItemMutation();
  const [ deleteConventionalDevicesCustomItem ] = useDeleteConventionalDevicesCustomItemMutation();

  const [showTools, setShowTools] = React.useState<boolean>(false);
  const [modifyRow, setModifyRow] = React.useState<boolean>(false);

  const isEmptyDetails =
      detailsEnabled &&
      (row.custom_item_id || row.custom_section_item_id) &&
      row.custom_description === "" &&
      row.manufacturer_name === "" &&
      row.article_number === "";



  const onlyCommentDetail =
      (row.custom_item_id || row.custom_section_item_id) &&
      row.custom_description !== "" &&
      (quoteUserProperties.include_article_number === 0 ||
          (quoteUserProperties.include_article_number === 1 && row.article_number === "")) &&
      (!row.manufacturer_name || row.manufacturer_name === "") &&
      (!row.design || row.design === "") &&
      (!row.color_name || row.color_name === "");

  const isMinusableTable =
      [
        "functiontable",
        "racktable",
        "projectcablestable",
        "convfunctiontable",
        "nhcdintable",
      ].indexOf(table.entitytype) !== -1;

  const rowId = row["custom_section_item_id"]
      ? row["custom_section_item_id"]
      : row["custom_item_id"]
          ? row["custom_item_id"]
          : row.rowIdx
              ? row.rowIdx
              : null;

  const deleteCustomRow = (row: any) => {
    if (isMinusableTable && !row.custom) {
      const alreadyMinusRow = rows.find(
          (x: any) => x.custom && x.product_id === row.product_id && x.quantity < 0
      );
      if (alreadyMinusRow) {
        setModifyMinusRow(alreadyMinusRow);
        setCurrentRowInEditing({
          entityId: table.id,
          entityType: table.entitytype,
          rowId: alreadyMinusRow["custom_item_id"],
        });
      } else {
        addMinusRow(
            row,
            table.entitytype,
            table.id,
            currency,
            addRoomCustomItem,
            addProjectCustomItem,
            addElectricalCustomItem,
            addNhcCustomItem,
            addRackCabinetCustomItem,
            addCableCustomItem,
            addConventionalDevicesCustomItem,
            addCustomSectionItem,
        );
        setCurrentRowInEditing({});
      }
    } else {
      deleteCustomItem(
          row,
          table.entitytype,
          deleteRoomCustomItem,
          deleteProjectCustomItem,
          deleteElectricalCustomItem,
          deleteNhcCustomItem,
          deleteCustomSectionItem,
          deleteRackCabinetCustomItem,
          deleteCableCustomItem,
          deleteConventionalDevicesCustomItem,
      );
      setCurrentRowInEditing({});
    }
  };

  const modifyCustomRow = (row: any) => {
    setModifyRow(false);
    setModifyMode(false);
    if (isMinusableTable) {
      const alreadyMinusRow = rows.find(
          (x: any) => x.custom && x.product_id === row.product_id && x.quantity < 0
      );
      if (alreadyMinusRow) {
        setModifyMinusRow(alreadyMinusRow);
        setCurrentRowInEditing({
          entityId: table.id,
          entityType: table.entitytype,
          rowId: alreadyMinusRow["custom_item_id"],
        });
      } else if (row.custom && row.quantity > 0) {
        setModifyRow(true);
        setModifyMode(true);
        setCurrentRowInEditing({
          entityId: table.id,
          entityType: table.entitytype,
          rowId: rowId,
        });
      } else {
        setCustomMinusRowButtonPressed(true);
        setCustomMinusItem({ ...row, quantity: -Math.abs(row.quantity) });
        setCurrentRowInEditing({
          entityId: table.id,
          entityType: table.entitytype,
          rowId: rowId,
        });
      }
    } else {
      setModifyRow(true);
      setModifyMode(true);
      setCurrentRowInEditing({
        entityId: table.id,
        entityType: table.entitytype,
        rowId: rowId,
      });
    }
  };

  const cancelModifyRow = () => {
    setModifyRow(false);
    setModifyMode(false);
    setCurrentRowInEditing({});
  };

  const cancelModifyMinusRow = () => {
    setModifyMinusRow(false);
    setModifyMode(false);
    setCurrentRowInEditing({});
  };

  // React.useEffect(() => {
  //   console.log('rows: ', rows)
  // }, []);

  React.useEffect(() => {
    if (
        modifyRow &&
        currentRowInEditing &&
        currentRowInEditing.entityId &&
        currentRowInEditing.entityType &&
        currentRowInEditing.rowId &&
        currentRowInEditing.entityId === table.id &&
        currentRowInEditing.entityType === table.entitytype &&
        currentRowInEditing.rowId === rowId
    ) {
      setTimeout(function () {
        const elem = document.querySelector(".modify-row");
        if (elem) {
          elem.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
        }
      }, 100);
    }
  }, [modifyRow]);

  React.useEffect(() => {
    if (
        modifyMinusRow &&
        currentRowInEditing &&
        currentRowInEditing.entityId &&
        currentRowInEditing.entityType &&
        currentRowInEditing.rowId &&
        currentRowInEditing.entityId === table.id &&
        currentRowInEditing.entityType === table.entitytype &&
        currentRowInEditing.rowId === rowId
    ) {
      setTimeout(function () {
        const elem = document.querySelector(".modify-minus-row");
        if (elem) {
          elem.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
        }
      }, 100);
    }
  }, [modifyMinusRow]);


  return (
      <tr
          role="row"
          className={`product-row ${index % 2 ? "even" : "odd"}} ${
          // className={`product-row ${index % 2 ? "even" : "odd"} ${hasMinusRow(rows, row.custom_item_id, row.product_id) ? 'remove-on-export' : ''} ${
              row["is_back_box"] ? "back-box" : ""
          } ${row.quantity < 0 ? "product-minus-row" : ""} ${
              modifyRow &&
              currentRowInEditing &&
              currentRowInEditing.entityId &&
              currentRowInEditing.entityType &&
              currentRowInEditing.rowId &&
              currentRowInEditing.entityId === table.id &&
              currentRowInEditing.entityType === table.entitytype &&
              currentRowInEditing.rowId === rowId
                  ? "modify-row"
                  : ""
          } ${
              modifyMinusRow &&
              row.custom &&
              row.product_id === modifyMinusRow.product_id &&
              row.quantity < 0 &&
              currentRowInEditing &&
              currentRowInEditing.entityId &&
              currentRowInEditing.entityType &&
              currentRowInEditing.rowId &&
              currentRowInEditing.entityId === table.id &&
              currentRowInEditing.entityType === table.entitytype &&
              currentRowInEditing.rowId === rowId
                  ? "modify-minus-row"
                  : ""
          }`}
          style={{ maxHeight: "186px" }}
          onMouseOver={() => {
            setShowTools(true);
          }}
          onMouseLeave={() => {
            setShowTools(false);
          }}
      >
        {modifyRow &&
        currentRowInEditing &&
        currentRowInEditing.entityId &&
        currentRowInEditing.entityType &&
        currentRowInEditing.rowId &&
        currentRowInEditing.entityId === table.id &&
        currentRowInEditing.entityType === table.entitytype &&
        currentRowInEditing.rowId === rowId ? (
            table.entitytype !== "roomtable_count" ? (
                <CustomModifyRow
                    projectId={projectId}
                    neededCols={neededCols}
                    cancelCustomRow={cancelModifyRow}
                    entityType={table.entitytype}
                    currency={currency}
                    modifyRow={modifyRow}
                    setModifyRow={setModifyRow}
                    modifyMode={modifyMode}
                    setModifyMode={setModifyMode}
                    showTools={showTools}
                    row={row}
                    dispatchDownloadStates={dispatchDownloadStates}
                    setCurrentRowInEditing={setCurrentRowInEditing}
                    measurementSystem={measurementSystem}
                    allManufacturerDiscountForProject={allManufacturerDiscountForProject}
                    manufacturerRecommendationForProject={manufacturerRecommendationForProject}
                />
            ) : null
        ) : modifyMinusRow &&
        row.custom &&
        row.product_id === modifyMinusRow.product_id &&
        row.quantity < 0 &&
        currentRowInEditing &&
        currentRowInEditing.entityId &&
        currentRowInEditing.entityType &&
        currentRowInEditing.rowId &&
        currentRowInEditing.entityId === table.id &&
        currentRowInEditing.entityType === table.entitytype &&
        currentRowInEditing.rowId === rowId ? (
            <CustomModifyMinusRow
                neededCols={neededCols}
                rows={rows}
                cancelCustomRow={cancelModifyMinusRow}
                entityType={table.entitytype}
                entityId={table.id}
                currency={currency}
                modifyRow={modifyMinusRow}
                setModifyRow={setModifyMinusRow}
                showTools={showTools}
                dispatchDownloadStates={dispatchDownloadStates}
                setCurrentRowInEditing={setCurrentRowInEditing}
                measurementSystem={measurementSystem}
            />
        ) : (
            <td colSpan={neededCols.length} style={{ padding: "5px 0" }}>
              <table width="100%">
                <tbody>
                <tr>
                  {neededCols.map((col: any, index: number) =>
                      col.data === "product_name" &&
                      detailsEnabled &&
                      !isEmptyDetails &&
                      (!onlyCommentDetail ||
                          (onlyCommentDetail &&
                              quoteUserProperties.include_comments === 1)) ? (
                          <PureTableCell
                              key={index}
                              col={col}
                              row={row}
                              showWrapper={true}
                              showIcon={true}
                              icons={icons}
                              table={table}
                              currency={currency}
                              dispatchDownloadStates={dispatchDownloadStates}
                              showTools={showTools}
                              deleteCustomRow={deleteCustomRow}
                              modifyCustomRow={modifyCustomRow}
                              measurementSystem={measurementSystem}
                          />
                      ) : null
                  )}
                </tr>
                <tr>
                  {neededCols.map((col: any, index: number) =>
                      col.data === "product_name" &&
                      (!detailsEnabled ||
                          isEmptyDetails ||
                          (onlyCommentDetail &&
                              quoteUserProperties.include_comments === 0)) ? (
                          <PureTableCell
                              key={index}
                              col={col}
                              row={row}
                              showWrapper={true}
                              showIcon={true}
                              icons={icons}
                              table={table}
                              currency={currency}
                              dispatchDownloadStates={dispatchDownloadStates}
                              showTools={showTools}
                              deleteCustomRow={deleteCustomRow}
                              modifyCustomRow={modifyCustomRow}
                              measurementSystem={measurementSystem}
                          />
                      ) : null
                  )}
                  {detailsEnabled && !isEmptyDetails ? (
                      <IDetails
                          cols={allCols}
                          row={row}
                          className={index % 2 ? "even" : "odd"}
                          colSpan={neededCols.length}
                          quoteUserProperties={quoteUserProperties}
                      />
                  ) : null}
                  {neededCols.map((col: any, index: number) =>
                      col.data !== "product_name" ? (
                          <PureTableCell
                              key={index}
                              col={col}
                              row={row}
                              showWrapper={false}
                              showIcon={false}
                              icons={icons}
                              table={table}
                              currency={currency}
                              dispatchDownloadStates={dispatchDownloadStates}
                              showTools={showTools}
                              deleteCustomRow={deleteCustomRow}
                              modifyCustomRow={modifyCustomRow}
                              measurementSystem={measurementSystem}
                          />
                      ) : null
                  )}
                </tr>
                </tbody>
              </table>
              {showTools ? (
                  <>
                      {row.specification_type === "installation" ||
                      row.specification_type === "personalisation" ? (
                          <ResetButton
                              table={table}
                              row={row}
                              currency={currency}
                              dispatchDownloadStates={dispatchDownloadStates}
                          />
                      ) : null}
                      {table.entitytype !== "roomtable" || row.custom ? (
                          <RowTools
                              deleteCustomRow={deleteCustomRow}
                              modifyCustomRow={modifyCustomRow}
                              table={table}
                              row={row}
                              currency={currency}
                          />
                      ) : null}
                  </>
              ) : null}
            </td>
        )}
      </tr>
  );
};
